export const CACHE_LIFESPAN = {
  defaultTTL: 5 * 60 * 1000, // 5m
  orgsName: 5 * 60 * 1000, // 5m
}
export const CACHE_NAME = 'console-careconne-jp';
